import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * STAŁA SZEROKOŚĆ = NAJDŁUŻSZY WARIANT (Piotr 7.10: „ten element nie może przeskakiwać przy zmianach
 * któregokolwiek z elementów”). Wszystkie warianty tekstu leżą niewidoczne w tej samej komórce siatki,
 * więc komórka ma szerokość najszerszego z nich — zmierzoną przez przeglądarkę w bieżącym języku
 * i kroju, bez zgadywania liczby znaków. Widoczna treść stoi na nich, wyrównana do `wyrownanie`.
 * Warianty są `aria-hidden`: czytnik ekranu czyta tylko treść.
 */
export function StalaSzerokosc({
  warianty,
  children,
  wyrownanie = 'start',
  className,
  testIdTresci,
  blok = false,
}: {
  warianty: string[];
  children: ReactNode;
  wyrownanie?: 'start' | 'end' | 'center';
  className?: string;
  /** `data-testid` WIDOCZNEJ treści — tekst całości zawiera też niewidoczne warianty. */
  testIdTresci?: string;
  /** `div` zamiast `span` (np. gdy treścią jest nagłówek `h1`). */
  blok?: boolean;
}) {
  const Tag = blok ? 'div' : 'span';
  return (
    // `display` w stylu, nie klasą: SelectTrigger (shadcn) nadaje dziecku `span` line-clamp
    // (`display: -webkit-box`), co ustawiało warianty obok siebie — 703 px zamiast najdłuższego.
    <Tag className={cn('overflow-visible', className)} style={{ display: 'inline-grid' }}>
      {warianty.map((w, i) => (
        <span key={i} aria-hidden="true" className="invisible col-start-1 row-start-1 whitespace-nowrap">
          {w}
        </span>
      ))}
      <Tag
        data-testid={testIdTresci}
        className={cn('col-start-1 row-start-1 whitespace-nowrap', wyrownanie === 'end' ? 'text-right' : wyrownanie === 'center' ? 'text-center' : 'text-left')}
      >
        {children}
      </Tag>
    </Tag>
  );
}

export default StalaSzerokosc;
